export default __webpack_public_path__ + "static/icon-19-2-38172fe40c74537f1eb0929eef9961a0.png";